import { deg2rad, lerp } from "./utils";

export class Vector {
  x = 0;
  y = 0;

  constructor(_x, _y) {
    this.x = _x;
    this.y = _y;

    return this;
  }

  clone() {
    return new Vector(this.x, this.y);
  }

  add({ x, y } = vectorLike) {
    this.x += x;
    this.y += y;

    return this;
  }

  lerp({ x, y } = vectorLike, t) {
    return new Vector(lerp(this.x, x, t), lerp(this.y, y, t));
  }

  getPointOnRadius(angle, radius) {
    const radians = deg2rad(angle);

    return new Vector(
      this.x + Math.cos(radians) * radius,
      this.y + Math.sin(radians) * radius
    );
  }

  distance({ x, y } = vectorLike) {
    return Math.hypot(x - this.x, y - this.y);
  }

  angle({ x, y } = vectorLike) {
    const dy = y - this.y;
    const dx = x - this.x;
    let theta = Math.atan2(dy, dx); // range (-PI, PI]
    theta *= 180 / Math.PI; // rads to degs, range (-180, 180]
    if (theta < 0) theta = 360 + theta;
    return theta;
  }
}

export class Bounds {
  constructor(tl, br) {
    this.tl = tl;
    this.br = br;
  }

  check({ x, y } = vectorLike) {
    return x >= this.tl.x && x <= this.br.x && y >= this.tl.y && y <= this.br.y;
  }
}
